import type { NotifyInterventionAssignProps } from "./intervention-action-assign.type";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { BatchPreviewAssignLink } from "@/modules/batch-preview/batch-preview-assign-link";
import { ModelLink } from "@/modules/model-link";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";
import { UserAvatar } from "@/ui/user-avatar";

export const notifyInterventionAssign = ({
  title,
  notify,
  payload,
}: NotifyInterventionAssignProps) => {
  const { context, event_type, user, interventions } = payload;
  const count = interventions.length;
  const ids = interventions.map(({ id }) => id);

  const onLinkClick = () => {
    notify.close(payload.id);
  };

  notify.info({
    key: payload.id,
    title,
    icon: (
      <UserAvatar
        size="small"
        statusColor="info"
        user={{ name: user.name }}
        withTooltip
      />
    ),
    actions: (
      <>
        {count === 1 ? (
          <ModelLink
            model="intervention"
            item={interventions[0]}
            showIcon
            modelAsName
            customContext={context}
            onClick={onLinkClick}
          />
        ) : (
          <BatchPreviewAssignLink
            type={event_type}
            userName={user.name}
            ids={ids}
            customContext={context}
            onClick={onLinkClick}
            icon="model"
          />
        )}
        <OrganizationContextLabel context={context} isSmall />
      </>
    ),
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
